<meta name="viewport" content="width=device-width, initial-scale=1.0"/>

@defer () {
  <div class="overlap-children w-[100%] flex" (mouseover)="onMouseOver()">
    <div
      class="entrance-card"
      [class.mobile-opacity-0p64]="notAccess"
      [ngClass]="{'bg-black-4 hover-unset' : notAccess }">
      <div class="image">
        <div [ngClass]="notAccess ? 'gradient-grey':'gradient-white'"></div>
        <img src="{{modalEntranceProps[title].imgSrc}}" (load)="incrementIconsAmount()"/>
      </div>
      <div class="text">
        <div class="card-title">
          <div class="icon">
            <app-entrance-modal-softwares-icons [software]="title"></app-entrance-modal-softwares-icons>
          </div>
          <div class="flex justify-between sm:justify-start gap-0.625 w-full">
            <div class="title content-center">{{title}}</div>
            @if (status === 'ai') {
              @let idAndDataQa = 'ai-button-for-' + title;
              <app-ai-button
                [attr.data-qa]="idAndDataQa"
                [id]="idAndDataQa"
                [fontClass]="'font-2em sm: text-[1.40625em]'"
                (mouseenter)="activateAiTooltipEmitter.emit(idAndDataQa)"
                (mouseleave)="deactivateAiTooltipEmitter.emit()">
                AI
              </app-ai-button>
            }
          </div>
        </div>
        <div class="subtitle">{{modalEntranceProps[title].description}}</div>
        @if (status || notAccess) {
          <app-soon-demo-not-active-tag [status]="notAccess ? 'request-demo' : status"/>
        }
      </div>

      <!-- Request demo card overlay-->
      @if (showTrialOverlay) {
        <div
          data-qa="trial-exp-card"
          class="overlay flex flex-col items-center content-center justify-center gap-[1rem]"
          (mouseleave)="onMouseLeave()">
          <app-all-icons [iconNameAndStyling]="'empty-exclamation.svg; black-9; icon-size-3'"></app-all-icons>
          <div class="font-2 bold500">Request demo</div>
          <app-button
            data-qa="request-demo"
            [size]="'medium'"
            [type]="'accent'"
            (buttonClick)="requestDemo()">
            Contact sales
          </app-button>
        </div>
      }
    </div>
  </div>
} @loading (minimum 0.15s) {
  <!-- LOADING STATE-->
  <div class="entrance-card">
    <div class="image flex flex-row items-center justify-center w-[100%]">
      <div class="bg-black-3 w-[95%] h-[90%] br-0p5"></div>
    </div>
    <div class="text">
      <div class="card-title">
        <div class="icon">
          <div class="w-[1.5em] h-[1.5em] bg-black-3 br-0p25"></div>
        </div>
        <div class=" h-[1.5em] bg-black-3 br-0p25">
          <div class="w-[9em] h-[1.5em]"></div>
        </div>
      </div>
      <div class="subtitle gap-[0.5rem] flex flex-col items-start">
        <div class="w-[20em] h-[1em] bg-black-3 br-0p25"></div>
        <div class="w-[9em] h-[1em] bg-black-3 br-0p25"></div>
      </div>
    </div>
  </div>
}
